/* eslint @typescript-eslint/no-explicit-any: 0 */
import * as React from 'react';
const sleep = (m: number) => new Promise((r) => setTimeout(r, m));

type componentType = React.ComponentClass | null;

interface IAsyncState {
    component: componentType;
}

const asyncComponent = (importComponent: any) => {
    class AsyncComponent extends React.Component<any, IAsyncState> {
        // The chunk can arrive after the route was left (or, in tests, after the environment was
        // torn down) — a late setState then has nothing to update and in jsdom throws.
        private isUnmounted = false;

        constructor(props: any) {
            super(props);

            this.state = {
                component: null,
            };
        }

        async componentDidMount() {
            await sleep(import.meta.env.MODE === 'development' ? 150 : 0);

            const { default: component } = await importComponent();

            if (this.isUnmounted) return;

            this.setState({
                component,
            });
        }

        componentWillUnmount() {
            this.isUnmounted = true;
        }

        render() {
            const C: componentType = this.state.component;

            return C ? <C {...this.props} /> : null;
        }
    }

    return AsyncComponent;
};

export default asyncComponent;
